import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OrganisationCommunicationType } from '../../../../shared/enums/OrganisationCommunicationType';

export interface ICcRecipientsDialogData {
    communicationType: OrganisationCommunicationType;
    ccRecipients: string[];
}

export type ICcRecipientsDialogResult = string[];

type CcRecipientsFormGroup = { email: FormControl<string> };

@Component({
    selector: 'app-cc-recipients-dialog',
    templateUrl: './cc-recipients-dialog.component.html',
    styleUrls: ['./cc-recipients-dialog.component.scss'],
    standalone: false
})
export class CcRecipientsDialogComponent implements OnInit {
    protected communicationType: OrganisationCommunicationType;
    protected ccRecipients: string[] = [];
    protected ccRecipientsForm: FormGroup<CcRecipientsFormGroup>;

    private readonly dialogRef: MatDialogRef<CcRecipientsDialogComponent, ICcRecipientsDialogResult> =
        inject(MatDialogRef);
    private readonly data: ICcRecipientsDialogData = inject(MAT_DIALOG_DATA);
    private readonly formBuilder: FormBuilder = inject(FormBuilder);

    ngOnInit() {
        this.communicationType = this.data.communicationType;
        this.ccRecipients = [...(this.data.ccRecipients ?? [])];
        this.ccRecipientsForm = this.formBuilder.group<CcRecipientsFormGroup>({
            email: new FormControl<string>('', [Validators.required, Validators.email])
        });
    }

    protected addRecipient(): void {
        if (this.ccRecipientsForm.invalid) {
            return;
        }

        const email = this.ccRecipientsForm.get('email').value?.trim();

        if (email && !this.ccRecipients.includes(email)) {
            this.ccRecipients = [...this.ccRecipients, email];
        }

        this.ccRecipientsForm.reset();
    }

    protected removeRecipient(email: string): void {
        this.ccRecipients = this.ccRecipients.filter(r => r !== email);
    }

    protected save(): void {
        this.dialogRef.close(this.ccRecipients);
    }

    protected cancel(): void {
        this.dialogRef.close();
    }
}
